export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'alaskaair',
    name: 'Alaska Airlines',
  },
  {
    id: 'ascent',
    name: 'Ascent',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'aspca',
    name: 'ASPCA',
  },
  {
    id: 'bankofamerica',
    name: 'Bank Of America',
  },
  {
    id: 'bestegg',
    name: 'Best Egg',
  },
  {
    id: 'bettermortgage',
    name: 'Better Mortgage',
  },
  {
    id: 'bluevine',
    name: 'Bluevine',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'charlesschwab',
    name: 'Charles Schwab',
  },
  {
    id: 'collegeave',
    name: 'College Ave',
  },
  {
    id: 'chase',
    name: 'Chase',
  },
  {
    id: 'chime',
    name: 'Chime',
  },
  {
    id: 'citi',
    name: 'Citi',
  },
  {
    id: 'discover',
    name: 'Discover',
  },
  {
    id: 'earnest',
    name: 'Earnest',
  },
  {
    id: 'fidelity',
    name: 'Fidelity Investments',
  },
  {
    id: 'geico',
    name: 'Geico',
  },
  {
    id: 'interactivebrokers',
    name: 'Interactive Brokers',
  },
  {
    id: 'lemonade',
    name: 'Lemonade',
  },
  {
    id: 'lendingclub',
    name: 'LendingClub',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'loansdepot',
    name: 'loanDepot',
  },
  {
    id: 'marcus',
    name: 'Marcus by Goldman Sachs',
  },
  {
    id: 'marriott',
    name: 'Marriott',
  },
  {
    id: 'navy',
    name: 'Navy Federal Credit Union',
  },
  {
    id: 'newtek',
    name: 'Newtek',
  },
  {
    id: 'pointsyeah',
    name: 'PointsYeah',
  },
  {
    id: 'realgenius',
    name: 'Real Genius',
  },
  {
    id: 'rocket',
    name: 'Rocket Mortgage',
  },
  {
    id: 'sofi',
    name: 'SoFi',
  },
  {
    id: 'sofistudentloans',
    name: 'SoFi Student Loans',
  },
  {
    id: 'travelers',
    name: 'Travelers',
  },
  {
    id: 'truist',
    name: 'Truist',
  },
  {
    id: 'united',
    name: 'United',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'upstart',
    name: 'Upstart',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'wealthfront',
    name: 'Wealthfront',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
  {
    id: 'zynlo',
    name: 'ZYNLO',
  },
];
